import {
  LoadingOutlined,
  EyeInvisibleOutlined,
  EyeTwoTone,
  LockOutlined
} from '@ant-design/icons';
import { Spin, Input } from 'antd';
import ReCAPTCHA from 'react-google-recaptcha';
import { Link } from 'react-router-dom';
import { T } from 'react-translator-component';

import * as S from './styled';
import { useChangePasswordPage } from './useChangePasswordPage';

import { useTheme } from '../../../../hooks/useTheme';
import { Shell } from '../../../atoms/Shell/Shell';
import { CelescLogos } from '../CelescLogos';

const ChangePasswordPage = () => {
  const { theme } = useTheme();

  const {
    handleFormSubmit,
    isLoginLoading,
    isVerified,
    recaptchaExpired,
    recaptchaLoaded,
    password,
    setPassword,
    validations,
    validatePassword,
    isPasswordValid
  } = useChangePasswordPage();

  return (
    <S.ChangePasswordFormPageWrapper>
      {theme ? (
        <img
          src={`https://storage.googleapis.com/mk-move-repository/white-label/${theme}/images/dash-logo.png`}
          className={`${theme}-logo-auth`}
        />
      ) : <Shell height={50} width={200}  />}

      <S.ChangePasswordFormWrapper>
        <S.ChangePasswordFormTitleWrapper>
          <S.ChangePasswordFormTitle>
            {T('Password recovery')}
          </S.ChangePasswordFormTitle>

          <p className="information">
            {T('Enter the verification code received in your email.')}
          </p>
        </S.ChangePasswordFormTitleWrapper>

        <form onSubmit={handleFormSubmit}>
          <S.ChangePasswordFormInputWrapper>
            <Input
              className="input"
              id="code"
              size="large"
              placeholder={T('Verification Code')}
              autoComplete="new-password"
            />
          </S.ChangePasswordFormInputWrapper>

          <S.ChangePasswordFormInputWrapper>
            <Input.Password
              className="input"
              id="password"
              type="password"
              size="large"
              prefix={<LockOutlined style={{'color':'#c1c6cb'}}/>}
              placeholder={T('Password')}
              iconRender={(visible) => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
              value={password}
              onChange={(e) => {
                const newPassword = e.target.value;
                setPassword(newPassword);
                validatePassword(newPassword);
              }}
              autoComplete="new-password"
            />
            <S.PasswordValidationList>
              <S.PasswordValidationItem isValid={validations.length}>
                {validations.length ? '✔' : '❌'} {T('8 to 25 characters')}
              </S.PasswordValidationItem>
              <S.PasswordValidationItem isValid={validations.uppercase}>
                {validations.uppercase ? '✔' : '❌'} {T('At least one uppercase letter')}
              </S.PasswordValidationItem>
              <S.PasswordValidationItem isValid={validations.lowercase}>
                {validations.lowercase ? '✔' : '❌'} {T('At least one lowercase letter')}
              </S.PasswordValidationItem>
              <S.PasswordValidationItem isValid={validations.special}>
                {validations.special ? '✔' : '❌'} {T('At least one special character')}
              </S.PasswordValidationItem>
              <S.PasswordValidationItem isValid={validations.number}>
                {validations.number ? '✔' : '❌'} {T('At least one number')}
              </S.PasswordValidationItem>
            </S.PasswordValidationList>
          </S.ChangePasswordFormInputWrapper>

          <S.ReCaptchaWrapper>
            <ReCAPTCHA
              sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
              render="explicit"
              onChange={recaptchaLoaded}
              onExpired={recaptchaExpired}
            />
          </S.ReCaptchaWrapper>

          {isLoginLoading ? (
            <Spin
              style={{ display: 'flex', justifyContent: 'center' }}
              indicator={<LoadingOutlined style={{ fontSize: 40, margin: 10 }} spin />}
            />
          ) : (
            <S.ChangePasswordFormButtonWrapper>
              <S.ChangePasswordFormButton
                type="submit"
                disabled={!isVerified || !isPasswordValid()}
                >
                {T('Submit')}
              </S.ChangePasswordFormButton>
            </S.ChangePasswordFormButtonWrapper>)}

          <S.RegisterText>
            <Link to="/auth/login">{T('Back to')} login.</Link>
          </S.RegisterText>
        </form>
      </S.ChangePasswordFormWrapper>

      {theme === 'celesc' && <CelescLogos />}
    </S.ChangePasswordFormPageWrapper>
  );
};

export default ChangePasswordPage;
